// extracted by mini-css-extract-plugin
export default {"tablehead":"DisposalDataTable_tablehead__c1N9q","custom-striped-table":"DisposalDataTable_custom-striped-table__4K7vl"};